module.exports = __webpack_public_path__ + "img/image02.39b7407d.jpg";